import {post} from './httpBase'
// 根据起止区域id获取到达起止点数组
export function getStation(params) {
    return post('/line/station/line', params)
}
export function getStartPoint(params) {
    return post('/line/station/info', params)
}
//下单接口
export function assistOrder(params) {
    return post('/order/intercity/assistorder', params)
}
//代下单计算价格接口
export function getPrice(params) {
    return post('/order/intercity/price', params)
}
//上车地址请求接口
export function startStation(params) {
    return post('/line/line/start', params)
}


// WEBPACK FOOTER //
// ./src/service/preOrderService.js